import { Flex } from 'antd';
import React from 'react';
import { formatDate } from '~/helpers/conversation';

import Attachment from './Attachment';

const messageTypeMapper = {
  customer: {
    position: 'self-start',
    backgroundColor: 'bg-dark-creme-background',
  },
  merchant: {
    position: 'self-end',
    backgroundColor: 'bg-lila-background',
  },
  default: {
    position: 'flex-start',
    backgroundColor: 'bg-grey-light',
  },
};

const getPosition = (type) => messageTypeMapper[type]?.position || messageTypeMapper.default.position;
const getBgColor = (type) => messageTypeMapper[type]?.backgroundColor || messageTypeMapper.default.backgroundColor;

function MessageBubble({ message, conversationId }) {
  return (
    <Flex vertical gap={8} className={`${getPosition(message.type)} max-w-[60%]`}>
      {message.content && message.content.replace(/\n/g, '<br />').length > 0 && (
        <Flex className={`flex rounded-md p-m ${getBgColor(message.type)}`} vertical gap={8}>
          <p className='body1 break-words' dangerouslySetInnerHTML={{ __html: message.content.replace(/\n/g, '<br />') }} />
        </Flex>
      )}
      {message.attachments.length > 0 && (
        <Flex gap={10} align='center'>
          {message.attachments.map((attachment) => (
            <Attachment key={attachment.id} attachment={attachment} conversationId={conversationId} backgroundColor={getBgColor(message.type)} />
          ))}
        </Flex>
      )}
      <p className={`body1 text-grey-medium ${getPosition(message.type)}`}>{formatDate(message.created_on)}</p>
    </Flex>
  );
}

export default MessageBubble;
